import React from "react";
import Shared02Headings from "../../guestsharedcomponents/Shared02Headings/Shared02Headings";
import ContainerHowItWorks from "./ContainerHowItWorks/ContainerHowItWorks";
import Shared01Buttons from "../../guestsharedcomponents/Shared01Buttons/Shared01Buttons";

const G05HowItWorks = () => {
  return (
    <section className="t-ptb-10 t-overflow-x-hidden">
      <div className="t-container">
        <Shared02Headings
          options={{
            style_render: "992",
            main_container_css: "",
            container_mobile_styles: {
              "max-width": "100rem",
              margin: "0 auto",
            },
            container_desktop_styles: false,
            obj_heading: {
              main_text: "A real learning system. Not random videos",
              main_tag_version: "h3",
              main_text_css: "t-h-4",
              heading_mobile_styles: {
                "text-align": "center",
                color: "#fff",
                "font-weight": "700",
                "margin-bottom": "0.5rem",
                "text-shadow":
                  "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
              },
              heading_desktop_styles: {},
            },
            obj_support_heading: {
              main_text:
                "<span class='t-enlace'>Built</span> With Structure. Designed for <span class='t-enlace'>Progress</span>.",
              main_tag_version: "h2",
              main_text_css: "t-h-1",
              heading_mobile_styles: {
                "text-align": "center",
                color: "#fff",
                "font-weight": "900",
                "margin-bottom": "0.5rem",
                "text-shadow":
                  "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
              },
              heading_desktop_styles: {},
            },

            obj_divider: {
              divider_mobile_styles: {
                width: "60%",
                background:
                  "linear-gradient(90deg, transparent, #e6c28b, transparent)",
                margin: "0 auto 3rem auto",
              },
              divider_desktop_styles: {},
            },
            obj_paragraph: {
              main_text:
                "LT Mastery is built as a complete online academy, not a collection of disconnected lessons. Every course, level, and progression path is intentionally designed to guide you step by step, so you always know what to train, when to train it, and why it matters",
              main_tag_version: "p",
              main_text_css: "",
              paragraph_mobile_styles: {
                color: "#fff",
                "font-size": "1.8rem",
                "margin-bottom": "5rem",
                "text-align": "center",
                "text-shadow":
                  "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
              },
              paragraph_desktop_styles: false,
            },
            obj_buttons: false,
            heading_version: "heading_01",
          }}
        />

        <ContainerHowItWorks />

        <Shared01Buttons
          options={{
            main_objinfo: {
              icon_left: false,
              icon_right: { icon: "fa-solid fa-arrow-right-long" },
              main_btn_heading: "Start Your Learning Today",
              main_btn_link: "https://members.ltmastery.com/",
              main_btn_container_classes: "t-btn-principal-1 t-mb-1 t-mr-1",
              main_btn_classes: "t-uppercase t-font-1-4",
              main_btn_version: "external_link_button", //main_button, internal_link_button, external_link_button
              main_btn_loader: false,
              main_handleClick: false,
            },
            secundary_objinfo: false,
            btn_main_container_classes: "t-flex-jsc",
          }}
        />
      </div>
    </section>
  );
};

export default G05HowItWorks;
